<h2 mat-dialog-title>{{ texts.title }}</h2>

<p class="fast-track-header">{{ texts.intro }}</p>

<mat-dialog-content>
  <h3 class="fast-track-company-name">{{ data.company.name }}</h3>
  <quill-view [content]="data.company.advice" [sanitize]="true"></quill-view>
</mat-dialog-content>

<app-divider color="second"></app-divider>
<div class="fast-track-footer">
  <p class="fast-track-explanation">{{ texts.explanation }}</p>
  <mat-checkbox [formField]="confirmationForm.confirmed">{{ texts.confirmationLabel }}</mat-checkbox>
</div>

<mat-dialog-actions>
  <button matButton="outlined" data-testid="fast-track-decline" [disabled]="submitting()" (click)="decline()">
    {{ texts.declineLabel }}
  </button>
  <button matButton="filled" data-testid="fast-track-continue" [disabled]="!canContinueWithConfirm()" (click)="confirm()">
    {{ texts.continueLabel }}
  </button>
</mat-dialog-actions>
